import React from "react";
import { UI } from "@wwimmo/ui";
import styles from "./AssemblyRealestateListRow.module.css";
import { AssemblyRealestate } from "src/stores/assemblies/AssemblyStore";
import { ColorStyle } from "src/utils/Colors";

export const AssemblyRealestateListRowMobile = (props: {
    assemblyrealestates: AssemblyRealestate;
    onRemoveRealestate: any;
}) => {
    const { realestate } = props.assemblyrealestates;
    const { onRemoveRealestate } = props;

    if (realestate === undefined) {
        return <div>/</div>;
    }

    return (
        <UI.List.Row className={styles.TicketListRowMobile} key={`row-mobile-${realestate.id}`}>
            <div className={styles.MobileTop}>
                <div className={styles.RealestateNames}>
                    <strong>
                        {realestate.name}
                        {realestate.number}
                    </strong>
                </div>
            </div>
            <div className={styles.MobileBottom}>
                <div className={styles.MobileLeft}>
                    {realestate.houses?.length !== undefined && realestate.houses?.length > 0 ? (
                        <div>
                            <div>
                                {realestate.houses[0].street} {realestate.houses[0].housenumber}
                            </div>
                            <div>
                                {realestate.houses[0].zip} {realestate.houses[0].city}
                            </div>
                        </div>
                    ) : (
                        <div></div>
                    )}
                </div>
            </div>
            <div>
                <UI.Icon
                    icon={UI.SVGIcon.Trash}
                    color={ColorStyle("primary")}
                    onClick={onRemoveRealestate(realestate.id)}
                />
            </div>
        </UI.List.Row>
    );
};
